import Layout from '@/layout'
// import routerView from '@/layout/routerView.vue'
const sysManageRouter = {
  path: '/sysManage',
  component: Layout,
  redirect: '/sysManage/agent',
  name: 'sysManage',
  permissionCode: '15878',
  meta: {
    title: '系统管理',
    icon: 'system'
  },
  children: [
    {
      path: 'agent',
      component: () => import('@/views/sysManage/page/agent.vue'),
      name: 'agent',
      permissionCode: '36309',
      meta: { title: '委托代理' }
    },
    {
      path: 'agentList',
      component: () => import('@/views/sysManage/page/agentList.vue'),
      name: 'agent',
      permissionCode: '36549',
      meta: { title: '代理记录' }
    },
    {
      path: 'user',
      component: () => import('@/views/sysManage/page/user.vue'),
      name: 'userSystem',
      permissionCode: '62912',
      meta: { title: '用户管理' }
    },
    {
      path: 'role',
      component: () => import('@/views/sysManage/page/role.vue'),
      name: 'roleSystem',
      permissionCode: '38120',
      meta: { title: '角色管理' }
    },
    {
      path: 'org',
      component: () => import('@/views/sysManage/page/org.vue'),
      name: 'orgSystem',
      permissionCode: '44589',
      meta: { title: '组织管理' }
    },
    {
      path: 'dictionary',
      component: () => import('@/views/sysManage/page/dictionary.vue'),
      name: 'dictionary',
      permissionCode: '15879',
      meta: { title: '数据字典' }
    }
  ]
}
export default sysManageRouter
